import { ValidatorFn, AsyncValidatorFn, FormGroup } from "@angular/forms";
import { DotNotation } from "@models/types/utils/DotNotation.type";
import { Configuration } from "./index.interface";

export enum ControlType {
  Text = 'text',
  Checkbox = 'checkbox',
  File = 'file',
  Image = 'image',
  Select = 'select',
  MultiSelect = 'multiselect',
  Radio = 'radio',
  Color = 'color',
  Date = 'date',
  Custom = 'custom',
  RichText = 'richtext'
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface DynamicFormConfig<T = any> {
  label: string;
  key: string;
  type: ControlType;
  value: unknown;
  validators?: ValidatorFn[];
  asyncValidators?: AsyncValidatorFn[];
  errorDisplayMode?: ErrorDisplayMode;
  isVisible?: (formGroup: FormGroup) => boolean;
  isDisabled?: (formGroup: FormGroup) => boolean;
  isEditable?: boolean;
  statePath?: DotNotation<Configuration>;
  cssClass?: string;
  placeholder?: string;
  fileTemplate?: string;
  selectConfig?: SelectConfig<T>;
  schemaObj?: unknown;
}

export enum ErrorDisplayMode {
  Always = 'always',
  Touched = 'touched',
  Dirty = 'dirty'
}

export interface SelectConfig<T> {
  options: T[];
  displayKey?: keyof T;
  valueKey?: keyof T;
}